var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.707 7.293a.996.996 0 0 0-1.41 0l-7.303 7.305-3.29-3.302a.997.997 0 1 0-1.41 1.411l4 4.003c.2.2.45.29.71.29.26 0 .51-.1.71-.29l7.993-7.996a.997.997 0 0 0 0-1.411v-.01Z"
  })));
};
export default SvgCheck;